module.exports = __webpack_public_path__ + "img/img-2.c8242f2b.png";